import { render, staticRenderFns } from "./AdminNewClassPopUp.vue?vue&type=template&id=787d8b73&scoped=true"
import script from "./AdminNewClassPopUp.vue?vue&type=script&lang=js"
export * from "./AdminNewClassPopUp.vue?vue&type=script&lang=js"
import style0 from "./AdminNewClassPopUp.vue?vue&type=style&index=0&id=787d8b73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787d8b73",
  null
  
)

export default component.exports